import styles from './Skeleton.module.css';

export interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  radius?: string;
  /** `| undefined` on purpose: see the note in `Term.tsx`. */
  className?: string | undefined;
}

/**
 * A placeholder box. Marked `aria-hidden` because it carries no information; the
 * container that is loading is what should announce the wait.
 */
export function Skeleton({ width = '100%', height = '1rem', radius, className }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={[styles.skeleton, className].filter(Boolean).join(' ')}
      style={{ width, height, borderRadius: radius }}
    />
  );
}
